import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cathegories',
  templateUrl: './cathegories.component.html',
  styleUrls: ['./cathegories.component.scss']
})
export class CathegoriesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
